<div class="confirm-dialog-container">
  <div class="dialog-header">
    <h2 mat-dialog-title>Confirm Action</h2>
    <button mat-icon-button (click)="onCancel()" class="close-button">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div mat-dialog-content class="dialog-content">
    <div class="warning-icon">
      <div class="warning-circle">
        <mat-icon>warning</mat-icon>
      </div>
    </div>

    <div class="warning-message">
      <p>
        You are about to apply <strong>"{{ data.snapshotName }}"</strong>. 
        All unsaved changes will be lost unless you save them as a new snapshot.
      </p>
    </div>
  </div>

  <div mat-dialog-actions class="dialog-actions">
    <button 
      mat-raised-button 
      color="warn" 
      (click)="onApplyWithoutSaving()"
      class="apply-without-saving-btn">
      Apply Without Saving
    </button>
    
    <button 
      mat-raised-button 
      color="primary" 
      (click)="onSaveAndApply()"
      class="save-and-apply-btn">
      Save Current & Apply Selected
    </button>
  </div>
</div> 